import { request } from '@umijs/max';

// 获取用户分页列表
export async function getUserPage(params: API.PageParams) {
  return request('/api/admin/user/page', {
    method: 'POST',
    data: {
      ...params,
      with: ['shop', 'rentFiles', 'sfzFiles', 'hukouFiles', 'dibaoFiles', 'nengliFiles'],
    },
  });
}

// 获取用户详情
export async function getUserInfo(params: { id: number }) {
  return request('/api/admin/user/info', {
    method: 'POST',
    data: {
      ...params,
      with: ['shop', 'rentFiles', 'sfzFiles', 'hukouFiles', 'dibaoFiles', 'nengliFiles'],
    },
  });
}

// 发放补贴
export async function sendButie(params: { id: number; zhekou: number; butie_max: number }) {
  return request('/api/admin/user/sendButie', {
    method: 'POST',
    data: params,
  });
}

// 编辑备注
export async function editRemark(params: { id: number; remark: string }) {
  return request('/api/admin/user/remark', {
    method: 'POST',
    data: params,
  });
}

// 新增用户
export async function addUser(params: API.FormValues) {
  return request('/api/admin/user/add', {
    method: 'POST',
    data: params,
  });
}

// 编辑用户
export async function editUser(params: API.FormValues) {
  return request('/api/admin/user/edit', {
    method: 'POST',
    data: params,
  });
}

// 删除用户
export async function removeUser(params: { id: number } | { ids: number[] }) {
  return request('/api/admin/user/remove', {
    method: 'POST',
    data: params,
  });
}
